module.exports = __webpack_public_path__ + "img/12-1.d7795265.png";